import { Environment } from '@/config'
import { useEffect } from 'react'

/**
 * useDebugButton Hook
 *
 * 该 Hook 用于在非生产环境下启用调试功能。
 * 它会动态导入 `@hotcoin/utils` 模块，并调用其中的 `debug.addDebugButton()` 方法，
 * 以在页面上添加一个调试按钮。
 *
 * 注意：此 Hook 仅在客户端执行，并且只在 `window.hotcoin` 不等于 `Environment.PRODUCTION` 时生效。
 */
const useDebugButton = () => {
  useEffect(() => {
    // 检查是否在浏览器环境中运行，并且当前环境不是生产环境
    if (typeof window !== 'undefined' && window.hotcoin !== Environment.PRODUCTION) {
      // 动态导入 @hotcoin/utils 模块
      import('@hotcoin/utils').then((module) => {
        // 调用模块中的 addDebugButton 方法，添加调试按钮
        module.debug.addDebugButton()
      })
    }
  }, []) // 空依赖数组确保 effect 只在组件挂载时执行一次
}

export default useDebugButton
